import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { InvoiceItem } from '@wilson/invoicing/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvoicingItemsGateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'invoice-items';

  getInvoiceItems(activityIds: string[]): Observable<InvoiceItem[]> {
    return this.http.post<InvoiceItem[]>(`${this.config.host}/${this.path}`, {
      activityIds,
    });
  }
}
